import { connect } from 'react-redux'
import { get, map } from 'lodash'

import PayWithApp from '../../components/richCheckout/PayWithApp'

import { getTotal, makeGetCartItems } from '../../selectors/cart'

const mapStateToProps = (state, ownProps) => {
  const deviceId = get(state, 'config.uuid', localStorage.getItem('device_id'))
  const { isScanned, orderNumber, orderUuid } = ownProps
  const total = getTotal(state)

  const getCartItems = makeGetCartItems()
  const items = getCartItems(state)
  const cartItems = items.map((item) => ({
      id: item.id,
      quantity: item.quantity,
      modifiers: map(item.modifiers, (modifierItem) => ({
        id: modifierItem.id,
        quantity: 1
      }))
  }))

  return {
    cartItems,
    deviceId,
    isScanned,
    orderNumber,
    total,
    orderUuid,
  }
}

export default connect(mapStateToProps, undefined)(PayWithApp)
